import { ThemeInterface } from "../../../styles/theme";
const styles = (theme: ThemeInterface) => ({
	triggerContainer: {
		display: "grid",
		gridTemplateColumns: "20px auto",
		width: "100%",
	},
	dashboardTrigger: {
		display: "flex",
		width: "400px",
		marginBottom: "10px",
		borderTop: `1px solid ${theme.palette.grey[200]}`,
		borderBottom: `1px solid ${theme.palette.grey[200]}`,
	},
	dashboardIcons: {
		marginLeft: "340px",
		padding: "7px",
	},
});

export default styles;
